// Per-viewer preference for how Google Maps renders — LIGHT, DARK, or
// FOLLOW_SYSTEM.  Backed by localStorage so the choice survives
// navigations and reloads; subscribers are notified when it changes so
// each open map can tear itself down and rebuild with the new
// colorScheme (a Map construction option that cannot be flipped on a
// live map).

const KEY = 'ndp-color-scheme';
const VALID = ['LIGHT', 'DARK', 'FOLLOW_SYSTEM'];
const DEFAULT = 'FOLLOW_SYSTEM';
const listeners = new Set();

export function current_color_scheme() {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (VALID.indexOf(stored) !== -1) return stored;
  } catch (e) {
    // private mode / storage disabled -> fall through
  }
  return DEFAULT;
}

export function set_color_scheme(scheme) {
  if (VALID.indexOf(scheme) === -1) return;
  try {
    window.localStorage.setItem(KEY, scheme);
  } catch (e) {
    // storage refused; still notify so live maps rebuild for this tab
  }
  listeners.forEach(fn => {
    try { fn(scheme); } catch (e) { /* one bad listener shouldn't stop others */ }
  });
}

export function subscribe_color_scheme_change(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
